var map = {
	"./customers/customers.module": [
		"./src/app/customers/customers.module.ts",
		"customers-customers-module"
	],
	"./help/help.module": [
		"./src/app/help/help.module.ts",
		"help-help-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./modals/add-customer/add-customer.module": [
		"./src/app/modals/add-customer/add-customer.module.ts"
	],
	"./modals/add-vehicle/add-vehicle.module": [
		"./src/app/modals/add-vehicle/add-vehicle.module.ts"
	],
	"./modals/card-payment/card-payment.module": [
		"./src/app/modals/card-payment/card-payment.module.ts"
	],
	"./modals/import-export-products/import-export-products.module": [
		"./src/app/modals/import-export-products/import-export-products.module.ts"
	],
	"./modals/re-print/re-print.module": [
		"./src/app/modals/re-print/re-print.module.ts"
	],
	"./modals/set-gate/set-gate.module": [
		"./src/app/modals/set-gate/set-gate.module.ts"
	],
	"./modals/ticket/ticket.module": [
		"./src/app/modals/ticket/ticket.module.ts"
	],
	"./modals/transaction-item/transaction-item.module": [
		"./src/app/modals/transaction-item/transaction-item.module.ts"
	],
	"./payment/payment.module": [
		"./src/app/payment/payment.module.ts",
		"payment-payment-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"products-products-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./report-details/report-details.module": [
		"./src/app/report-details/report-details.module.ts",
		"report-details-report-details-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports-reports-module"
	],
	"./reprint/reprint.module": [
		"./src/app/reprint/reprint.module.ts",
		"reprint-reprint-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./ticket/ticket.module": [
		"./src/app/ticket/ticket.module.ts",
		"ticket-ticket-module"
	],
	"./transaction/transaction.module": [
		"./src/app/transaction/transaction.module.ts",
		"transaction-transaction-module"
	],
	"./transactions/transactions.module": [
		"./src/app/transactions/transactions.module.ts",
		"transactions-transactions-module"
	],
	"./vehicles/vehicles.module": [
		"./src/app/vehicles/vehicles.module.ts",
		"vehicles-vehicles-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;